/**
 * Batch / total counts for the Drops advanced filter panel.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

interface DropsFilterStatsBarProps {
  shownCount: number;
  loadedCount: number;
  totalSmswiser: number;
  fetchEstimate?: number;
  dateRangeActive?: boolean;
}

function StatChip({ label, value }: { label: string; value: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1 text-xs">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-semibold tabular-nums text-foreground">{value}</span>
    </span>
  );
}

export const DropsFilterStatsBar: FC<DropsFilterStatsBarProps> = ({
  shownCount,
  loadedCount,
  totalSmswiser,
  fetchEstimate,
  dateRangeActive = false,
}) => (
  <div className="space-y-2">
    <div className="flex flex-wrap items-center gap-2">
      <StatChip label="Matching" value={shownCount.toLocaleString()} />
      <StatChip label="Loaded" value={loadedCount.toLocaleString()} />
      <StatChip label="SMSWiser total" value={totalSmswiser.toLocaleString()} />
      {dateRangeActive && fetchEstimate != null ? (
        <StatChip label="Est. target" value={fetchEstimate.toLocaleString()} />
      ) : null}
    </div>
    {dateRangeActive ? (
      <p className="text-[11px] leading-relaxed text-muted-foreground">
        With a date range, Fetch loads from SMSWiser in 5k pages until your start date is covered.
        Loaded can exceed Est. target.
      </p>
    ) : null}
  </div>
);

export default DropsFilterStatsBar;
